export const organisationRoles = [
  'owner',
  'admin',
  'manager',
  'coordinator',
  'staff',
  'finance',
  'auditor'
] as const;

export type OrganisationRole = (typeof organisationRoles)[number];

export type CoreResource = 'organisation' | 'location' | 'staff' | 'service';
export type CoreAction = 'read' | 'create' | 'update' | 'archive';

const managementRoles: readonly OrganisationRole[] = ['owner', 'admin', 'manager'];

export function can(role: OrganisationRole, action: CoreAction, resource: CoreResource): boolean {
  if (action === 'read') return true;
  if (resource === 'organisation') return ['owner', 'admin'].includes(role);
  return managementRoles.includes(role);
}
